// Only used after an explicit open/redock. Keep an already visible panel still,
// otherwise retain as much board context as fits alongside stats and Bet.
export const revealDockedStats = (panel) => {
  if (!panel) return;
  const rect = panel.getBoundingClientRect();
  const top = (document.querySelector('.site-header')?.getBoundingClientRect().bottom || 0) + 8;
  const nav = document.querySelector('.mobile-bottom-navigation');
  const bottom = nav?.getClientRects().length ? nav.getBoundingClientRect().top : window.innerHeight;
  if (rect.top >= top && rect.bottom <= bottom - 8) return;
  const board = panel.closest('.keno-game')?.querySelector(':scope > .keno-stage, :scope > .original-stage, :scope > .bj-table');
  const contextTop = (board?.getBoundingClientRect().top ?? rect.top) + window.scrollY - top - 4;
  const statsAndBetTop = rect.bottom + window.scrollY + 60 - bottom;
  window.scrollTo({ top: Math.max(0, contextTop, statsAndBetTop), behavior: 'auto' });
};